// extracted by mini-css-extract-plugin
module.exports = {"tabBar":"TabBar_tabBar__3JKk9"};